import React from "react";
import { Button, Stack, alpha } from "@mui/material";
import {
  Refresh as RefreshIcon,
  ArrowBack as BackIcon,
  AccountBalanceWallet as WalletIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PageContentLayout from "../components/layout/PageContentLayout";
import WhatsAppPricePlan from "../components/whatsapp/admin/WhatsAppPricePlan";
import { crmColors } from "../theme/colors";

const WA = crmColors.whatsapp;
const WA_DARK = "#1DA851";

/**
 * Dedicated page for school WhatsApp Tech Provider plans
 * (tm_whatsapp_subscription_plans).
 */
const WhatsAppPricePlansPage = () => {
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = React.useState(0);
  const [addRequestKey, setAddRequestKey] = React.useState(0);

  return (
    <PageContentLayout
      title="WhatsApp Price Plans"
      subtitle="School packages by category"
      breadcrumbs={[
        {
          label: "WhatsApp Price Plans",
          icon: <WalletIcon sx={{ color: "#ffffff", fontSize: 18 }} />,
        },
      ]}
      backTo="/whatsapp/accounts"
      actions={
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button
            variant="outlined"
            size="small"
            startIcon={<BackIcon />}
            onClick={() => navigate("/whatsapp/accounts")}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              borderColor: alpha(WA, 0.4),
              color: WA_DARK,
              "&:hover": { borderColor: WA, bgcolor: alpha(WA, 0.08) },
            }}
          >
            Accounts
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={() => setRefreshKey((k) => k + 1)}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              borderColor: alpha(WA, 0.4),
              color: WA_DARK,
              "&:hover": { borderColor: WA, bgcolor: alpha(WA, 0.08) },
            }}
          >
            Refresh
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => setAddRequestKey((k) => k + 1)}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 700,
              bgcolor: WA,
              "&:hover": { bgcolor: WA_DARK },
            }}
          >
            Add plan
          </Button>
        </Stack>
      }
    >
      <WhatsAppPricePlan
        activeOnly={false}
        editable
        refreshSignal={refreshKey}
        openCreateSignal={addRequestKey}
      />
    </PageContentLayout>
  );
};

export default WhatsAppPricePlansPage;
